import { Routes, Route } from "react-router-dom";
import { AppProvider } from "../../context/formflow/AppContext";
import { Toast } from "../../components/formflow/Toast";
import { Dashboard } from "./Dashboard";
import { Builder } from "./Builder/Builder";
import { SendFormPage } from "./SendForm";
import { FillFormPage } from "./FillForm";
import { SubmissionsPage } from "./Submissions";
import { EnvelopeViewPage } from "./EnvelopeViewPage";
import { CompletedFormViewPage } from "./CompletedFormViewPage";
import { SettingsPage } from "./Settings";

function FormFlowRoutes() {
  return (
    <AppProvider>
      <div className="text-left">
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="builder" element={<Builder />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="send/:formId" element={<SendFormPage />} />
          <Route path="sign/:token" element={<FillFormPage />} />
          <Route path="completed/:token" element={<CompletedFormViewPage />} />
          <Route path="submissions" element={<SubmissionsPage />} />
          <Route path="submissions/:formId" element={<SubmissionsPage />} />
          <Route path="view/:envelopeId" element={<SubmissionsPage />} />
          <Route path="envelope/:envelopeId" element={<EnvelopeViewPage />} />
        </Routes>
        <Toast />
      </div>
    </AppProvider>
  );
}

export default FormFlowRoutes;
